/* eslint-disable no-underscore-dangle */
import { createSelector } from '@ngrx/store';

import { Location, LocationsMap } from '@fcom/core-api/interfaces';
import { safeSelect, StateSelector } from '@fcom/core/selectors/selector-utils';
import { LocationsState } from '@fcom/locations/interfaces/locations-state.interface';
import { BookingTripLocations } from '@fcom/common-booking/interfaces';
import { Step } from '@fcom/common/interfaces';

import {
  BookingAppState,
  BookingFeatureState,
  BookingFlow,
  BookingLocationCodes,
  BookingState,
} from '../../interfaces';
import { bookingFeatureState } from './booking-feature-state.selector';

const mapToLocation = (locations: LocationsMap, locationCode: string): Location =>
  !locationCode ? undefined : locations?.[locationCode] || ({ locationCode } as Location);

const toBookingTripLocations = (
  locationCodes: BookingLocationCodes[],
  locations: LocationsMap
): BookingTripLocations[] | undefined => {
  return locationCodes?.map((location) => ({
    origin: mapToLocation(locations, location.originLocationCode),
    destination: mapToLocation(locations, location.destinationLocationCode),
  }));
};

const _locationsMapFromState = createSelector(
  (appState: BookingAppState) => appState?.locations,
  (locationsState: LocationsState) => locationsState?.locations
);

const _bookingState = createSelector(bookingFeatureState, (_bs: BookingFeatureState) => _bs?.booking);
export const _bookingFlowSelector = createSelector(_bookingState, (_bs: BookingState) => _bs?.flow);
export const _bookingLocationCodes = createSelector(_bookingFlowSelector, (_flow: BookingFlow) => _flow?.locations);

export const bookingLocationsSelector = createSelector(
  _bookingLocationCodes,
  _locationsMapFromState,
  toBookingTripLocations
);

const _bookingStep = createSelector(_bookingState, (_state) => _state?.step);

export const bookingFlow = (): StateSelector<BookingFeatureState, BookingFlow> => safeSelect(_bookingFlowSelector);
export const bookingLocationCodes = (): StateSelector<BookingFeatureState, BookingLocationCodes[]> =>
  safeSelect(_bookingLocationCodes);
export const bookingLocations = (): StateSelector<BookingFeatureState, BookingTripLocations[]> =>
  safeSelect(bookingLocationsSelector);
export const bookingStep = (): StateSelector<BookingFeatureState, Step> => safeSelect(_bookingStep);
